import { createRouter, createWebHistory } from 'vue-router'
import { auth } from '@/firebase/auth'
import { onAuthStateChanged } from 'firebase/auth'
import HomeView from '../views/home/HomeView.vue'
import LoginView from '../views/LoginView.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/register-your-beys',
    name: 'RegisterYourBeys',
    component: () => import(/* webpackChunkName: "RegisterYourBeys" */ '../views/RegisterYourBeys.vue')
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import(/* webpackChunkName: "account" */ '../views/user/UserView.vue')
  },
  {
    path: '/randomizer',
    name: 'Randomizer',
    component: () => import(/* webpackChunkName: "randomizer" */ '../views/RandomizerView.vue')
  },
  {
    path: '/tournament-ban',
    name: 'TournamentBan',
    component: () => import(/* webpackChunkName: "tournament-ban" */ '../views/TournamentBanView.vue')
  },
  {
    path: '/rules',
    name: 'Rules',
    component: () => import(/* webpackChunkName: "rules" */ '../views/RulesView.vue')
  },
  {
    path: '/tournament',
    name: 'TournamentDoor',
    component: () => import(/* webpackChunkName: "rules" */ '../views/tournament/TournamentDoorView.vue')
  },
  {
    path: '/tournament-manager/:id',
    name: 'TournamentManager',
    component: () => import(/* webpackChunkName: "rules" */ '../views/tournament/TournamentManagerView.vue')
  },
  {
    path: '/tournament-lobby/:id',
    name: 'TournamentLobby',
    component: () => import(/* webpackChunkName: "rules" */ '../views/tournament/TournamentLobbyView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const user = auth.currentUser

  if (to.path !== '/login' && !user) {
    onAuthStateChanged(auth, (firebaseUser) => {
      if (firebaseUser) {
        next()
      } else {
        next('/login')
      }
    })
  } else {
    next()
  }
})

export default router
